import type { ProductCard } from '@akademi/site-builder-runtime';

/** A missing, future or delayed stock state must never be labelled "In stock". */
export function availabilityLabel(availability: ProductCard['availability']): string {
  switch (availability) {
    case 'IN_STOCK': return 'home.inStock';
    case 'LOW_STOCK': return 'home.lowStock';
    case 'OUT_OF_STOCK': return 'home.outOfStock';
    case 'PREORDER': return 'home.preorder';
    case 'BACKORDER': return 'home.backorder';
    default: return 'home.availabilityUnknown';
  }
}
